(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
     
  class KsLookBook extends HTMLElement {
  constructor() {
    super();

    this.injectVendorScripts();
    this.querySelectorAll('.ks-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem);
    });
  }

  async injectVendorScripts() {
    if (!window.FloatingUICore) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
      document.head.appendChild(script);
    }

    if (!window.FloatingUIDOM) {
      await new Promise(r => setTimeout(r, 500)); // short delay to allow core to load

      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
      document.head.appendChild(script);
    }
  }

handleTooltip(elem) {
  const btn = elem.querySelector('button');
  const tooltip = elem.querySelector('.ks-tooltip');

  function update() {
    window.FloatingUIDOM.computePosition(btn, tooltip, {
      middleware: [
        window.FloatingUIDOM.offset(0),
        window.FloatingUIDOM.autoPlacement(),
      ],
    }).then(({ x, y }) => {
      Object.assign(tooltip.style, {
        left: `${x}px`,
        top: `${y}px`,
        position: 'absolute',
        zIndex: 1000,
      });
    });
  }

  function hideAllTooltips() {
    document.querySelectorAll('.ks-tooltip.show').forEach((t) => {
      t.classList.remove('show');
    });
  }

  function showTooltip() {
    hideAllTooltips(); // hide any open tooltip
    tooltip.classList.add('show');
    update();
  }

  function hideTooltip() {
    tooltip.classList.remove('show');
  }

  // Show on hover (desktop)
  ['mouseenter', 'focus'].forEach(event => {
    btn.addEventListener(event, showTooltip);
  });

  // Show on touch/click (mobile)
  btn.addEventListener('touch', function (e) {
    e.preventDefault();
    if (tooltip.classList.contains('show')) {
      hideTooltip();
    } else {
      hideAllTooltips(); // hide others before showing
      showTooltip();
    }
  });

  // Hide on mouseleave (desktop)
  tooltip.addEventListener('mouseleave', hideTooltip);

  // Hide when tapping outside (mobile)
  document.addEventListener('click', function (e) {
    if (!elem.contains(e.target)) {
      hideTooltip();
    }
  });
}

    
}

customElements.define('ks-lookbook', KsLookBook);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs_marquee"] && !Shopify.designMode) return;
  try {
    
class BwMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.bw-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #bw-marquee-${this.dataset.sectionId} ul {
          animation-name: bw-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes bw-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes bw-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('bw-marquee', BwMarquee)


  } catch(e) { console.error(e); }
})();
})();
